import { unescapeReferenceToken } from '@criteria/json-pointer'
import { SecurityScheme as SecuritySchemeV3_0 } from '@criteria/openapi/v3.0'
import { SecurityScheme as SecuritySchemeV3_1 } from '@criteria/openapi/v3.1'
import { invariant } from '../../lib/invariant'
import { Change, OpenAPI } from './Change'

export type SecuritySchemeRef = `#/components/securitySchemes/${string}`
export type SecurityScheme = SecuritySchemeV3_0 | SecuritySchemeV3_1

export class AddSecurityScheme extends Change {
  constructor(readonly ref: SecuritySchemeRef, readonly value: SecurityScheme) {
    super()
  }

  apply(document: OpenAPI): void {
    let match = this.ref.match(/^#\/components\/securitySchemes\/([^/]*)$/)
    if (match !== null) {
      const identifier = unescapeReferenceToken(match[1])

      document.components ??= {}
      document.components.securitySchemes ??= {}

      invariant(
        document.components.securitySchemes[identifier] === undefined,
        `Security scheme at ${this.ref} already exists`
      )
      document.components.securitySchemes[identifier] ??= this.value
    }
  }
}

export class DeleteSecurityScheme extends Change {
  constructor(readonly ref: SecuritySchemeRef) {
    super()
  }

  apply(document: OpenAPI): void {
    let match = this.ref.match(/^#\/components\/securitySchemes\/([^/]*)$/)
    if (match !== null) {
      const identifier = unescapeReferenceToken(match[1])

      const securitySchemes = (document.components ?? {})['securitySchemes']
      if (securitySchemes) {
        delete securitySchemes[identifier]
      }
    }
  }
}
